
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import { sharedState } from '../../../../framework/state';

import { CostReport } from '../../../../../common/application/model/report/CostReport';
import { formatCurrency } from '../../../service/helper_service';
import { fakeCostReportData } from "../../../service/report_service";

@Component
export default class BudgetTable extends Vue {
    @Prop(Array) readonly rows!: CostReport[];
    @Prop(Boolean) readonly showWithVat!: boolean;

    shared = sharedState;

    local = {
        columns: [] as any,
        rows: [] as CostReport[],
    };

    @Watch('rows')
    async rowsChanged(rows: CostReport[]) {
        this.local.rows = [...rows];
        if (rows.length === 0) {
            this.generateFakeData();
        }
    }

    formatCurrencyValue(value: number | null | undefined) {
        return formatCurrency(value);
    }

    private generateFakeData(): void {
        this.local.rows = [...fakeCostReportData(this)];
    }
}
